import React, { Component } from "react";
import FormFeilds from "../../UI/formfeilds";
import { validate } from "../../utils/minc";
import { db, Timestamp } from "../../firebase";

export default class ContactForm extends Component {
  state = {
    formError: false,
    formSuccess: "",
    formData: {
      name: {
        element: "input",
        value: "",
        config: {
          name: "name_input",
          type: "text",
          placeholder: "Enter Your Name"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: ""
      },
      email: {
        element: "input",
        value: "",
        config: {
          name: "email_input",
          type: "email",
          placeholder: "Enter Your email"
        },
        validation: {
          required: true,
          email: true
        },
        valid: false,
        validationMessage: ""
      },
      message: {
        element: "textarea",
        value: "",
        config: {
          name: "message_input",
          type: "text",
          rows: 7,
          placeholder: "Enter Your message"
        },
        validation: {
          required: true
        },
        valid: false,
        validationMessage: ""
      }
    }
  };
  resetFormSuccess = type => {
    const newFormdata = { ...this.state.formData };
    for (let key in newFormdata) {
      newFormdata[key].value = "";
      newFormdata[key].valid = false;
      newFormdata[key].validationMessage = "";
    }
    this.setState({
      formError: false,
      formData: newFormdata,
      formSuccess: type
        ? "I got the message"
        : "Email already exists in the database"
    });
    this.successMessage();
  };
  successMessage = () => {
    setTimeout(() => {
      this.setState({ formSuccess: "" });
    }, 3000);
  };
  updateForm = element => {
    const newFormdata = { ...this.state.formData };
    const newElement = { ...newFormdata[element.id] };
    newElement.value = element.event.target.value;

    let validateData = validate(newElement);
    newElement.valid = validateData[0];
    newElement.validationMessage = validateData[1];
    newFormdata[element.id] = newElement;
    this.setState({ formError: false, formData: newFormdata });
  };
  submitForm = event => {
    event.preventDefault();
    let dataToSubmit = {};
    let formIsValid = true;
    for (let key in this.state.formData) {
      dataToSubmit[key] = this.state.formData[key].value;
      formIsValid = this.state.formData[key].valid && formIsValid;
    }
    dataToSubmit.timeStamp = Timestamp.fromDate(new Date());
    if (formIsValid) {
      console.log(dataToSubmit);
      db.collection("messages")
        .where("email", "==", dataToSubmit.email)
        .get()
        .then(querySnapshot => {
          if (querySnapshot.size === 0) {
            db.collection("messages")
              .doc()
              .set(dataToSubmit)
              .then(() => {
                this.resetFormSuccess(true);
              })
              .catch(error => {
                console.log(error);
                this.setState({
                  formError: true
                });
              });
          } else {
            this.resetFormSuccess(false);
          }
        });
    } else {
      this.setState({
        formError: true
      });
    }
  };
  render() {
    return (
      <div className="contact-form">
        <div className="message">
          {this.state.formError ? (
            <div style={{ color: "red" }}>Something is wrong try again</div>
          ) : null}
          {this.state.formSuccess.length > 0 ? (
            <div style={{ color: "#7174cf" }}>{this.state.formSuccess}</div>
          ) : null}
        </div>
        <form onSubmit={this.submitForm}>
          <p>Name</p>
          <FormFeilds
            id="name"
            formData={this.state.formData.name}
            change={element => this.updateForm(element)}
          />
          <p>E-mail</p>
          <FormFeilds
            id="email"
            formData={this.state.formData.email}
            change={element => this.updateForm(element)}
          />
          <p>Message</p>
          <FormFeilds
            id="message"
            formData={this.state.formData.message}
            change={element => this.updateForm(element)}
          />
          <br />
          <button type="submit">SEND</button>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Contact/contactForm.js